import Helper from './Helper';

class FrontpageSideNav {
  constructor(config = {}) {
    const {
      navItem,
      parent
    } = config;
    this.navi = Array.prototype.slice.call(document.querySelectorAll(navItem));
    this.sibling = document.querySelector('.header__langs');
    this.parent = document.querySelector(parent);
    this.body = document.querySelector('body');
    if(this.navi.length > 0 && Helper.hasClass(this.body, 'home')) {
      this.makeItem(this.navi);
    }
  }

  makeItem(titleArray){
    const ulTag = document.createElement('ul');
    Helper.addClass(ulTag, 'side-menu');
    Helper.addClass(ulTag, 'header__side-menu');

    titleArray.forEach(el => {
      const href = el.querySelector('a').getAttribute("href");
      const text = el.querySelector('.menu__link-text').innerText;
      const liTag = document.createElement('li');
      liTag.classList.add('side-menu__item', 'side-menu__item--level-0', 'side-menu__item--has-no-children','side-menu__item--active')
      const aTag = document.createElement('a');
      aTag.classList.add('side-menu__link', 'side-menu__link--level-0','side-menu__item--has-no-children')
      aTag.setAttribute('href', href);
      const spanTag = document.createElement('span');
      Helper.addClass(spanTag, 'side-menu__link-text');
      spanTag.innerHTML = text;

      aTag.appendChild(spanTag);
      liTag.appendChild(aTag);
      ulTag.appendChild(liTag);
    });
    Helper.addBefore(ulTag, this.sibling);
  }

}

export default FrontpageSideNav;
